import React, { ReactNode } from 'react'
import { BsPrinter } from 'react-icons/bs'
interface CircleBtnProps {
  onClick: () => void;
  icon?: ReactNode;
}
const CircleBtn: React.FC<CircleBtnProps> = ({ onClick, icon = <BsPrinter /> }) => {
  return (
    <button onClick={onClick} className='rounded-full p-1 z-30 static shadow-lg border-slate-400 bg-slate-400 hover:bg-slate-500 text-white'>{icon}</button>
  )
}

export default CircleBtn